module.exports = __webpack_public_path__ + "img/四川天府新区永兴幼儿园.c49be163.jpg";